module.exports = __webpack_public_path__ + "static/media/logo.e0ebbfe5.svg";